<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import { sourceAndDestinationType } from 'pando-constants';

export default {
  methods: {
    constructContractCheckPayload(currentSelectedDrop = null) {
      const payload = {
        sources: [],
        destinations: [],
      };
      this.sourcesDropOffs.forEach((sourceDropOffDetail) => {
        const source = {
          type: parseInt(sourceDropOffDetail.type, 10),
          location_id: sourceDropOffDetail.id, // source id
        };
        sourceDropOffDetail.pickups.forEach((pickup) => {
          const pickupDetails = {
            ...(pickup.id !== source.location_id ? { gate_id: pickup.id } : {}),
          };
          payload.sources.push({ ...source, ...pickupDetails });
          if (this.selectedPickupData === pickup) {
            if (this.selectedDrops) {
              this.selectedDrops.forEach((drop) => {
                const destination = this.getDropPayload(drop, source, pickup);
                payload.destinations.push(destination);
              });
            }
            if (currentSelectedDrop) {
              const destination = {
                type: parseInt(currentSelectedDrop.type, 10),
                location_id: currentSelectedDrop.location_id ||
                  currentSelectedDrop.id, // destination ship to id
                source_location_id: source.location_id, // source id
                source_gate_id: pickup.id, // source gate id
              };
              if (destination.type === sourceAndDestinationType.DEPOT) {
                destination.gate_id = currentSelectedDrop.id;
              }
              payload.destinations.push(destination);
            }
          } else if (pickup.dropoffs) {
            pickup.dropoffs.forEach((drop) => {
              const destination = this.getDropPayload(drop, source, pickup);
              payload.destinations.push(destination);
            });
          }
        });
      });
      return payload;
    },
    async checkContract(currentSelectedDrop = null) {
      // construct the payload for checking a contract is present or not
      try {
        const payload = this.constructContractCheckPayload(currentSelectedDrop);
        if (payload.sources.length !== 0 && payload.destinations.length !== 0) {
          const result = await this.$store.dispatch(
            'indentV2/getContract',
            payload,
          );
          if (!result || result.error) {
            this.$errorMessage({
              message: this.$t('INDENT_CONTRACT_LOADING_ERROR_MSG'),
            });
            this.changeOrderType('OPEN');
          } else if (result && result.length) {
            this.changeContractVehicles(result);
          } else {
            return false;
          }
          return !!(result && result.length);
        }
        return true;
      } catch (err) {
        this.$errorMessage({
          message: this.$t('INDENT_CONTRACT_LOADING_ERROR_MSG'),
        });
        this.changeOrderType('OPEN');
        return false;
      }
    },

    getDropPayload(drop, source, pickup, pointType = null, addRef = false) {
      const destination = {
        type: parseInt(drop.ship_to.type, 10),
        location_id: drop.ship_to.location_id || drop.ship_to.id, // destination ship to id
        source_location_id: source.location_id, // source id
        source_gate_id: pickup.id, // source gate id
      };
      if (pointType) {
        destination.pointType = pointType;
      }
      if (addRef) {
        destination.ref_id = drop.ship_to.reference_id;
      }
      if (destination.type === sourceAndDestinationType.DEPOT) {
        destination.gate_id = drop.ship_to.id;
      }

      return destination;
    },

    async confirmationBox(text, buttonText, title, dispalyCancelButton = true,
      displayClose = true) {
      return this.$PromptConfirm(text, title, {
        confirmButtonText: buttonText,
        showCancelButton: dispalyCancelButton,
        lockScroll: true,
        showClose: displayClose,
        center: true,
      });
    },

    async openSwitchOpenIndentDialog(dispalyCancelButton = true, displayClose = true) {
      this.$addGAEvent('Indent Management', 'Popup', 'Add/Edit Outbound/Inbound Indent:Open Indent Popup');
      let userResponse = false;
      if (this.$hasPermission('create_open_indent')) {
        await this.confirmationBox(
          this.$t('INDENT_CONTRACT_NOT_FOUND_PROMPT'),
          this.$t('INDENT_SWITCH_TO_OPEN'),
          this.$t('INDENT_NO_CONTRACTS'),
          dispalyCancelButton,
          displayClose,
        )
          .then(async () => {
            await this.setOrderType('OPEN');
            userResponse = true;
          })
          .catch(() => {
            userResponse = false;
          });
      } else {
        this.$alert({
          message: this.$getConst('INDENT_NO_CONTRACT'),
        });
      }
      return userResponse;
    },
  },
};
</script>
